import * as React from 'react'
import { IOnlineProps } from './IOnlineProps'

export const OnlineContext: React.Context<IOnlineProps> = React.createContext<
  IOnlineProps
>({ online: true })



// WEBPACK FOOTER //
// ./src/components/OnlineDetect/context.ts